// extracted by mini-css-extract-plugin
export default {"page":"StatsDetail_page__qU-qZ","errorCard":"StatsDetail_errorCard__dLeKp"};